import React from "react";
import {
    ButtonIconCopyClipboard,
    ButtonIconEdit,
    SelectField,
} from "../../../../Components/Inputs";
import {HtmlDisplay} from "../../../../Components/Display";
import {OWN_LOAN_STATUS_LIST} from "./ownLoanConstants";
import {truncateString} from "../../../../Utilities/commonUtilities";
import {convertToCurrencyFormat} from "./ownLoanUtility";
import {OwnLoanItem} from "./ownLoan.types";
import type {ListItem} from "../../../../Utilities/Types/listUtilities";

interface OwnLoanRowProps {
    ownLoanItem: OwnLoanItem;
    canManageOwnLoans: boolean;
    handleCopyToClipboard: () => void;
    handleOpenEditDialog: (event: React.MouseEvent<HTMLElement>, item: OwnLoanItem) => void;
    handleUpdateOwnLoanStatus: (itemId: string, status: string | number) => void;
}

export const OwnLoanRow = ({
                               ownLoanItem,
                               canManageOwnLoans,
                               handleCopyToClipboard,
                               handleOpenEditDialog,
                               handleUpdateOwnLoanStatus
                           }: OwnLoanRowProps) => {

    const handleOwnLoanStatusChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        event.preventDefault();
        handleUpdateOwnLoanStatus(ownLoanItem.ownLoanItemId, event.target.value);
    };

    return (
        <tr id={ownLoanItem.ownLoanItemId}>
            <td>
                {ownLoanItem.dateCreatedFormatted}
            </td>
            <td>
                {ownLoanItem.ownCatalogItemTitle}
            </td>
            <td>
                {ownLoanItem.quantity}
            </td>
            <td>
                {convertToCurrencyFormat(ownLoanItem.ownCatalogItemCost)}
            </td>
            <td>
                {ownLoanItem.patronFullName}
            </td>
            <td>
                {ownLoanItem.districtName}
            </td>
            <td>
                {ownLoanItem.organization}
            </td>
            <td>
                {ownLoanItem.shippingLocationName}
            </td>
            <td>
                {ownLoanItem.ownCatalogNumber}
            </td>
            <td>
                {
                    canManageOwnLoans ?
                        <SelectField
                            hideLabel
                            includeDefaultOption={false}
                            label={`Own Item Status for ${ownLoanItem.ownCatalogItemTitle}`}
                            name={`own-loan-status-${ownLoanItem.ownLoanItemId}`}
                            onChange={(event: React.ChangeEvent<HTMLSelectElement>) => handleOwnLoanStatusChange(event)}
                            options={OWN_LOAN_STATUS_LIST}
                            value={ownLoanItem.ownLoanStatus}
                        />
                        :
                        <HtmlDisplay
                            html={OWN_LOAN_STATUS_LIST.find((f: ListItem) => f.value === ownLoanItem.ownLoanStatus)?.text || ``}
                            name={`loan-own-status-${ownLoanItem.ownLoanItemId}`}
                        />
                }
            </td>
            <td>
                {truncateString(ownLoanItem.ownLoanNotes)}
            </td>
            <td className={`align-center`}>
                {
                    canManageOwnLoans &&
                    <ButtonIconEdit
                        inputDescription={`for ${ownLoanItem.ownCatalogItemTitle}`}
                        onClick={(event) => event && handleOpenEditDialog(event, ownLoanItem)}
                    />
                }
                <ButtonIconCopyClipboard
                    inputDescription={`for ${ownLoanItem.ownCatalogItemTitle}`}
                    onClick={handleCopyToClipboard}
                />
            </td>
        </tr>
    );
};
